import { createInitialState } from '../types/internal';
import type { AICXConfig } from '../types/config';
import type { AICXInternalState } from '../types/internal';

/**
 * SDK 내부 상태 관리자
 * 싱글톤 패턴으로 전역 상태 관리
 */
class AICXStateManager {
  private state: AICXInternalState;

  constructor() {
    this.state = createInitialState();
  }

  /** 현재 상태 조회 (읽기 전용) */
  getState(): Readonly<AICXInternalState> {
    return this.state;
  }

  /** 설정 저장 */
  setConfig(config: AICXConfig): void {
    this.state.config = config;
  }

  /** 초기화 완료 표시 */
  setInitialized(value: boolean): void {
    this.state.initialized = value;
  }

  /** 열림 상태 변경 */
  setIsOpen(value: boolean): void {
    this.state.isOpen = value;
  }

  /** iframe 참조 저장 */
  setIframe(iframe: HTMLIFrameElement | null): void {
    this.state.iframe = iframe;
  }

  /** 컨테이너 참조 저장 */
  setContainer(container: HTMLDivElement | null): void {
    this.state.container = container;
  }

  /** 상태 완전 초기화 (destroy 시 호출) */
  reset(): void {
    this.state = createInitialState();
  }
}

/** 싱글톤 인스턴스 */
export const stateManager = new AICXStateManager();
